(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ServiceOptionItemCustom', ServiceOptionItemCustom);

    ServiceOptionItemCustom.$inject = ['$resource'];

    function ServiceOptionItemCustom($resource) {


        var ServiceOptionItemsByServiceItem = function (serviceItemId) {
            var resourceUrl = 'api/service-option-items-by-service-item/' + serviceItemId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var ServiceOptionItemsSelectedInOrderBag = function (serviceItemId, orderBagServiceItemId) {
            var resourceUrl = 'api/service-option-items-selected-in-order-bag/' + serviceItemId + '/' + orderBagServiceItemId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var removeOptionInfoFromServiceItem = function (serviceItemId, serviceOptionInfoId) {
            var resourceUrl = 'api/remove-service-option-from-service-item/' + serviceItemId + '/' + serviceOptionInfoId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };


        return {
            ServiceOptionItemsByServiceItem: ServiceOptionItemsByServiceItem,
            ServiceOptionItemsSelectedInOrderBag: ServiceOptionItemsSelectedInOrderBag,
            removeOptionInfoFromServiceItem: removeOptionInfoFromServiceItem

        };
    }
})();
